import { Component, Input, SimpleChanges, SimpleChange } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { AbstractFormComponent } from '../../../../core/abstract-form-component';
import { SettingsHttpService } from '../../../../services/settings/settings.http.service';
import { StorageUtil } from '../../../../utils/storage.util';
import { SettingsHttpUtil } from '../settings.util';
import { AuthUtil } from '../../../../utils/auth.utils';

@Component({
  moduleId: module.id,
  selector: 'bft-phone-settings',
  templateUrl: 'phone.settings.component.html'
})
export class PhoneSettingsComponent extends AbstractFormComponent {

  @Input()
    phone;

  @Input()
    display;

  changeModeStatus: boolean = false;

  constructor(private formBuilder: FormBuilder, private settingsHttpService: SettingsHttpService, private authUtil: AuthUtil) {
    super();
  }

  buildForm(): FormGroup {
    return this.formBuilder.group({
      phone: [this.phone, [Validators.required]],
    });
  }

  getValidationMessages(): {} {
    return {
      'phone': {
        'required': 'Данное поле обязательно для заполнения.',
      },
    };
  }

  submit() {
    if(this.phone === this.form.value.phone) {
      this.changeModeStatus = false;
      return;
    }

    let data = {
      securityToken: StorageUtil.getToken(),
      phoneVal: this.form.value.phone,
    };

    let requestParams = SettingsHttpUtil.prepareParamsSettings(data);
    this.settingsHttpService.setSettings(requestParams).subscribe(
      success => {
        if (success) {
          this.changeModeStatus = false;
          this.phone = this.form.value.phone;

          this.authUtil.checkErrorResponse(success.json());
        }
      },
      error => {
      },
      () => {
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    const display: SimpleChange = changes.display;
    if(display.currentValue) {
      this.changeModeStatus = false;
      this.form.setValue({phone: this.phone});
    }
  }

  toggleChangeStatus($event) {
    $event.preventDefault();

    this.changeModeStatus = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/settings/phone/phone.settings.component.ts